export default __webpack_public_path__ + "static/media/GOOGLE_ASSISTANT.33ffcd38.png";